import styled from 'styled-components'

export const SelectButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: ${props => (props.$hasLineBreak ? 'auto' : props.theme.sizes.forms.height)};
	min-height: ${props => props.theme.sizes.forms.height};
	padding: ${props => (props.$hasLineBreak ? '12px' : '8px 16px')};
	border: 1px solid ${props =>
		props.$error
			? props.theme.colors.feedback.error
			: props.theme.colors.greys.defaultBorder};
	border-radius: 8px;
	background-color: white;
	color: ${props =>
		props.$isEmpty
			? props.theme.colors.greys.disabledGrey
			: props.theme.colors.text.primaryText};
	font-size: 1rem;
	cursor: pointer;
	text-align: left;
	outline: none;
	&:focus {
		border-color: ${props => props.theme.colors.brand.blueOmint};
		box-shadow: 0 0 0 2px ${props => props.theme.colors.brand.backgroundBlue};
	}
`

export const SelectLabel = styled.label`
	display: flex;
	font-size: 16px;
	font-weight: 500;
	color: ${props => props.theme.colors.text.primaryText};
	margin-bottom: 8px;
`

export const SelectWrapper = styled.div`
	display: flex;
	flex-direction: column;
`

export const ModalSearchField = styled.div`
	width: 100%;

	input:hover {
		border-color: ${props => props.theme.colors.greys.defaultBorder};
		box-shadow: none;
	}

	div:hover {
		color: ${props => props.theme.colors.text.secondaryText};
	}
`

export const ModalActions = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
`

export const FiltersContainer = styled.div`
	width: 100%;
	margin-bottom: 16px;
	${({ $isMobile }) =>
		$isMobile &&
		`
		display: flex;
		flex-direction: column;
		flex: 1;
		height: 100%;
		min-height: 0;
		margin-bottom: 0px;
	`}

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		flex-direction: column;
		flex: 1;
		height: 100%;
		min-height: 0;
	}
`

export const FiltersGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 24px;
	width: 100%;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		grid-template-columns: 1fr;
		flex: 1;
		align-content: start;
	}
`

export const GridItem = styled.div`
	width: 100%;
`

export const ButtonRow = styled.div`
	margin-top: 24px;
	width: 100%;
	${({ $isMobile, theme }) =>
		$isMobile &&
		`
		margin-top: auto;
		padding-top: 24px;
		padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);
		background: ${theme.colors.brand.white};
	`}

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		margin-top: auto;
		padding-top: 24px;
		padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);
		background: ${props => props.theme.colors.brand.white};
	}

	@media (min-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 50%;
	}
`

export const SelectedTagsContainer = styled.div`
	margin-top: 12px;
	padding: 12px 0;
	border-top: 1px solid ${props => props.theme.colors.greys.defaultBorder};
	border-bottom: 1px solid ${props => props.theme.colors.greys.defaultBorder};
`

export const TagsLabel = styled.span`
	font-size: 14px;
	font-weight: 500;
	color: ${props => props.theme.colors.text.primaryText};
	margin-right: 8px;
`

export const TagsRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	align-items: center;
`
